import { BuildingLibraryIcon } from '@heroicons/react/24/outline'
import { RegionMetaPills } from '@/components/regionen/regionMeta/RegionMetaPills'
import { Img } from '@/components/shared/Img'
import { Link } from '@/components/shared/links/Link'
import { Pill } from '@/components/shared/text/Pill'
import type { TRegion } from '@/server/regions/regionConfigMapper.server'

type Props = { region: TRegion }

export const RegionTeaser = ({ region }: Props) => {
  const customLogo = region.logoPath
  const contract = region.contract

  return (
    <Link to="/regionen/$regionSlug" params={{ regionSlug: region.slug }} classNameOverwrite="">
      <div
        key={region.slug}
        className="group relative border-r border-b border-gray-200 px-4 pt-4 hover:bg-yellow-50 sm:px-6 sm:pt-6"
      >
        {contract ? (
          <Pill
            color="gray"
            className="absolute top-3 left-3 z-10 max-w-[calc(100%-1.5rem)] shadow-sm sm:top-4 sm:left-4"
          >
            {contract.name}
          </Pill>
        ) : null}
        <RegionMetaPills
          region={region}
          className="absolute top-3 right-3 z-10 max-w-[calc(100%-1.5rem)] justify-end sm:top-4 sm:right-4"
          pillClassName="shadow-sm"
        />
        <div className="aspect-auto h-20 overflow-hidden rounded-lg border border-gray-200 bg-white group-hover:opacity-75">
          <span className="flex h-full w-full items-center justify-center object-cover object-center py-2">
            {customLogo && <Img src={customLogo} className="max-h-full w-auto" alt="" />}
            {!customLogo && <BuildingLibraryIcon className="block h-20 w-auto" />}
          </span>
        </div>
        <h3 className="flex min-h-32 items-center justify-center text-center text-xl leading-tight font-medium text-gray-900">
          TILDA <br />
          {region.fullName}
        </h3>
      </div>
    </Link>
  )
}
